import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { MatPageable, PageableResponse } from '@core/table/mat-table';
import {AlteracaoSenha, UsuarioCadastro, UsuarioCombo} from '@core/models/usuario';
import { HttpHeaders } from '@angular/common/http';
import { buildQueryString } from '@shared/util/util';


const baseRef = 'usuarios';
const route = {
  consultar: `${baseRef}/consultar`,
  exportarExcel: `${baseRef}/consultar?formato=xlsx`,
  salvar: `${baseRef}/registrar`,
  buscarPorid: (id: number) => `${baseRef}/${id}`,
  editar: (id: number) => `${baseRef}/${id}`,
  alterarstatus: (id: number,acao:string) => `${baseRef}/alterar-status/${id}/${acao}`,
  trocarSenha: `${baseRef}/senha`,
  reenviarLinkAtivacao: (id: number) => `${baseRef}/reenviar-link/${id}`,
  buscarTodos: `${baseRef}/todos`,
  buscarTodosCombo: `${baseRef}/todos-combo`,
  buscarEmail: (email: string) => `${baseRef}/username/${email}`,
  buscarLoginEmailPublico: (email: string) => `publica/${baseRef}/login/${email}`
}

@Injectable({
  providedIn: 'root'
})
export class UsuarioService {

  constructor(private apiService: ApiService) {

  }

  consultar(filtro: any, page: MatPageable) {
    return this.apiService.post<PageableResponse<any>>(`${route.consultar}${page.query}`, this.apiService.removeNullPropertys(filtro));
  }

  consultarSort(filtro: any, page: MatPageable, params: any) {
    const queryString = buildQueryString({...params });
    const fullUrl = `${route.consultar}${page.query}${queryString}`;
    return this.apiService.post<PageableResponse<any>>(
      fullUrl,
      this.apiService.removeNullPropertys(filtro)
    );
  }

  exportarExcel(filtro: any) {
    return this.apiService.downloadPost(route.exportarExcel, this.apiService.removeNullPropertys(filtro));
  }

  salvar(usuario: UsuarioCadastro) {
    if (usuario.id)
      return this.editar(usuario);
    else
      return this.apiService.post<any>(route.salvar, usuario);
  }

  buscarPorId(id: number) {
    return this.apiService.get<any>(route.buscarPorid(id));
  }

  editar(usuario: UsuarioCadastro) {
    return this.apiService.put<any>(route.editar(usuario.id), usuario);
  }

  inativar(id: number) {
    return this.apiService.get<any>(route.alterarstatus(id, 'inativar'));
  }

  bloquear(id: number) {
    return this.apiService.get<any>(route.alterarstatus(id, 'bloquear'));
  }

  desbloquear(id: number) {
    return this.apiService.get<any>(route.alterarstatus(id, 'desbloquear'));
  }

  trocarSenha(senha: AlteracaoSenha) {
    return this.apiService.put<any>(route.trocarSenha, senha);
  }


  reenviarLinkAtivacao(id: number) {
    return this.apiService.get<any>(route.reenviarLinkAtivacao(id));
  }


  buscarTodos() {
    return this.apiService.get<any>(route.buscarTodos);
  }

  buscarTodosCombo() {
    return this.apiService.get<UsuarioCombo[]>(route.buscarTodosCombo);
  }

  buscarEmail(email: string) {
    return this.apiService.get<any>(route.buscarEmail(email));
  }


  buscarLoginEmailPublico(email: string) {
    return this.apiService.get<any>(route.buscarLoginEmailPublico(email));
  }
}
